import { Navigate, useLocation } from 'react-router-dom';
import Layout from '@/layout';
import TabLayout from '@/layout/Tabbar';
import Token from '@/page/token';
import Referral from '@/page/referral';
import Account from '@/page/account';
import NewTrade from '@/page/trade';
import Meme from '@/page/token/meme';
import Trending from '@/page/token/trending';
import Signal from '@/page/token/signal';
import Treasures from '@/page/token/treasures';
import { useAppStore } from '@/store';

export interface IRoutes {
  path?: string;
  element: JSX.Element;
  children?: IRoutes[];
  auth?: boolean;
}

const NotFoundRedirect = () => {
  const {
    chainInfo: { path },
  } = useAppStore();
  const location = useLocation();
  return <Navigate to={`/${path}/token/signal${location.search}`} replace />;
};
export const routes: IRoutes[] = [
  {
    element: <Layout />,
    children: [
      {
        element: <TabLayout />,
        children: [
          {
            path: '/token',
            element: <Token />,
            children: [
              {
                path: '/token/trending',
                element: <Trending />,
              },
              {
                path: '/token/meme',
                element: <Meme />,
              },
              {
                path: '/token/signal',
                element: <Signal />,
              },
              {
                path: '/token/treasures',
                element: <Treasures />,
              },
              {
                path: '',
                element: <Navigate to="/token/signal" replace />,
              },
            ],
          },
          {
            path: '/account',
            element: <Account />,
          },
          {
            path: '/trade/:address',
            element: <NewTrade />,
          },
          {
            path: '/',
            element: <NotFoundRedirect />,
          },
          {
            path: '*',
            element: <NotFoundRedirect />,
          },
        ],
      },
      {
        element: <Referral />,
        auth: true,
        path: '/referral',
      },
    ],
  },
];
